export default __webpack_public_path__ + "static/media/bootstrap.adb47c07.svg";